export const REVIEWS = "Відгуків";
export const AT_RECEPTION =
  "Прийом з лікарем може здійснитися як у форматі онлайн-консультації за допомогою засобів зв’язку, так і при безпосередньому відвідуванні медустанови.";
export const POP_UP_DOC_APPOINTMENT_1 = [
  "Лікар:",
  "Спеціальність:",
  "Дата:",
  "Час:",
  "Адреса:",
  "Кабінет:",
];
export const POP_UP_DOC_APPOINTMENT_1_VALUE = {
  doctor: "Князєва Ольга Станіславівна",
  speciality: "Сімейний лікар",
  data: "18.05.2023",
  time: "10:00-11:00",
  address: "м. Київ, вул. Попудренка, 7",
  office: "Кабінет №2",
};
export const POP_UP_DOC_APPOINTMENT_2_TITLE = "Ваш запис успішно відправлено";
export const POP_UP_DOC_APPOINTMENT_2_ALERT =
  "Очікуйте підтвердження від лікаря в особистому кабінеті.";
export const POP_UP_DOC_APPOINTMENT_2_GRATITUDE =
  "Дякуємо що обираєте beHealth, ми трудимось над тим, щоб Вам було зручно користуватись сервісом.";
export const BUTTON_SHOW_MORE = "Показати більше";
export const BUTTON_SHOW_LESS = "Згорнути";
